import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const PERMISSION_BASE_URL = '/rest/api/3/mypermissions';
const CREATE_SHARED_OBJECTS_PERMISSION_PARAM = 'permissions=CREATE_SHARED_OBJECTS';

export const getCreateSharedObjectsPermission = async (): Promise<boolean | undefined> => {
	try {
		const myPermission = await performGetRequest(
			`${PERMISSION_BASE_URL}?${CREATE_SHARED_OBJECTS_PERMISSION_PARAM}`,
		);

		return myPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		log.safeErrorWithoutCustomerData(
			'itsm-features.services.common.shared-object-permission.getCreateSharedObjectsPermission',
			'Unable to fetch create shared objects permission',
			error,
		);
		return undefined;
	}
};
